/*
 * Copyright (C) Regione Lombardia
 */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { LayoutAlertModalComponent } from "@layout/alert-modal/alert-modal.component";
import { LayoutConfirmModalComponent } from "@layout/confirm-modal/confirm-modal.component";
import { LayoutDialogComponent } from "@layout/dialog/dialog.component";
import {
  AnagraficaStatoOpera,
  DatalistAnagrafica,
  DocumentoOpera,
  Manutenzione,
  Monitoraggio,
  Opera,
  OperaSecondaria,
  OperaStatoEnum,
  PianoInterventi,
  Rilevamento,
} from "@models";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { OperaService } from "@shared/services/opera.service";
import { PermessiService } from "@shared/services/permessi.service";
import { UtenteService } from "@shared/services/utente.service";
import { UtilsService } from "@shared/services/utils.service";
import {CoreI18nConfigs} from "@core/configs/i18n.config";
import { MonitoraggiSopralluoghi } from "src/app/_models/domain/monitoraggi-sopralluoghi";
import { ModalMotivazioneComponent } from "../_toolkit/modal-motivazione/modal-motivazione.component";
import { RollbackOpera } from "src/app/_models/domain/rollback-opera";
import { ModalRollbackOperaComponent } from "../_toolkit/modal-rollback-opera/modal-info-rollback-opera.component";

@Component({
  selector: "app-dettaglio-opera",
  templateUrl: "./dettaglio-opera.component.html",
})
export class PagesGestioneOperaDettaglioOperaComponent
    implements OnInit, OnDestroy
{
  public datalist: DatalistAnagrafica;
  public statoOperaSelect: AnagraficaStatoOpera[];
  public operaSecondariaList: OperaSecondaria[] = [];
  public documentoOperaList: DocumentoOpera[] = [];
  public criteriaForm: FormGroup;
  public rilevamentoList: Rilevamento[] = [];
  public manutenzioneList: Manutenzione[] = [];
  public monitoraggioList: Monitoraggio[] = [];
  public monitoraggiSopralluoghiList: MonitoraggiSopralluoghi[] = [];
  public pianoInterventiList: PianoInterventi[] = [];
  public formStato: FormGroup;
  public readonly VERIFICATA = OperaStatoEnum.VERIFICATA;
  public windowClosed: boolean = false;
  public showActions = true;
  public changedWithMotivation = false;

  constructor(
      public operaService: OperaService,
      public utenteService: UtenteService,
      public permessiService: PermessiService,
      private utilsService: UtilsService,
      private router: Router,
      private route: ActivatedRoute,
      private fb: FormBuilder,
      private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.datalist = this.route.snapshot.data["additionalInformation"].datalist;
    this.operaSecondariaList =
        this.route.snapshot.data["additionalInformation"].operaSecondaria;
    this.documentoOperaList =
        this.route.snapshot.data["additionalInformation"].documentoOpera;
    this.rilevamentoList =
        this.route.snapshot.data["additionalInformation"].rilevamento;
    this.manutenzioneList =
        this.route.snapshot.data["additionalInformation"].manutenzione;
    this.monitoraggioList =
        this.route.snapshot.data["additionalInformation"].monitoraggio;
    this.monitoraggiSopralluoghiList =
        this.route.snapshot.data["additionalInformation"].monitoraggiSopralluoghi;
    this.pianoInterventiList =
        this.route.snapshot.data["additionalInformation"].pianoInterventi;
    this.criteriaForm = this.operaService.generateFormOpera(
        this.operaService.operaSession
    );
    this.initFormStato();
    this.operaService.setRequiredValidators(this.criteriaForm);
    document.addEventListener("visibilitychange", this.onVisiblePage);
  }

  ngOnDestroy() {
    document.removeEventListener("visibilitychange", this.onVisiblePage);
  }

  public goToModifica() {
    this.router.navigate(["modifica"], { relativeTo: this.route });
  }

 public goToCronologiaModifiche(): void {
        const idOpera = this.operaService.operaSession?.idOpera;
        if (!idOpera) {
            this.utilsService.showWarning('Impossibile determinare l\'opera');
            return;
        }

        this.operaService.getRollbackOpera(idOpera).subscribe({
            next: (resp: any) => {
                // normalizza la response in array (può tornare singolo oggetto o array)
                const entries: any[] = !resp ? [] : (Array.isArray(resp) ? resp : [resp]);
                console.log('Cronologia modifiche recuperata:', entries);
                const mapped = (entries || []).map((it: any) => ({
                     data: it.dataCompletamento,
                     utente: it.idUtenteModifica || '',
                     motivazione: it.notaMotivazione || '',
                     ente: it.ente || ''
                 }))
         
                 const modalRef = this.modalService.open(ModalRollbackOperaComponent, { size: 'xl', centered: true });
                 modalRef.componentInstance.title = 'Cronologia modifiche';
                 console.log('Apro modal cronologia modifiche con entries:', mapped);
                 modalRef.componentInstance.entries = mapped;
            },
            error: (err) => {
                console.error('Errore recupero cronologia modifiche', err);
                this.utilsService.showError('Errore durante il recupero della cronologia modifiche.');
            }
        });
    }

  
  public goBack() {
    if (this.operaService.pageTypeSession === "approva-opera") {
      this.router.navigate(["../../approva-opera"], { relativeTo: this.route });
      return;
    }
    this.router.navigate([".."], { relativeTo: this.route });
   }

  public deleteOpera() {
    this.operaService
        .delete(this.operaService.operaSession.idOpera)
        .subscribe((response) => {
          if (this.utilsService.genericResponse204NoContent(response)) {
            this.router.navigate([".."], { relativeTo: this.route });
          }
        });
  }

  public workflowNext() {
    const statoToBe = this.permessiService.opera["OPERA_CHANGE_ALL_STATO"]
        ? this.formStato.get("stato")?.value
        : this.operaService.operaSession.idStato + 1;
    if (
        (this.criteriaForm.get("tipoInserimento")?.value === 1 &&
            this.pianoInterventiList.length === 0) ||
        ((this.operaService.operaSession.idRilievo === null ||
                this.operaService.operaSession.idRilievo === undefined) &&
            this.criteriaForm.get("tipoInserimento")?.value === 2)
    ) {
      const modal = this.modalService.open(LayoutAlertModalComponent, {
        size: "xs",
      });
      const isProgetto = this.criteriaForm.get("tipoInserimento")?.value === 1;
      const tipoInserimentoText = isProgetto ? "progetto" : "rilievo";
      const errorMessage = `Nessun ${tipoInserimentoText} associato. Per poter procedere è necessario associare un ${tipoInserimentoText}.`;
      modal.componentInstance.description = errorMessage;
    } else {
      this.operaService
          .workflowNext(this.operaService.operaSession.idOpera, statoToBe)
          .subscribe((response) => {
            if (this.utilsService.genericResponse204NoContent(response)) {
              /* Aggiorno i dati in sessione */
              this.operaService
                  .read(this.operaService.operaSession.idOpera)
                  .subscribe((responseOpera) => {
                    this.operaService.operaSession = responseOpera;
                    this.permessiService.initPermessiOpera();
                    this.initFormStato();
                  });
            }
          });
    }
    if (this.changedWithMotivation) {
      const rollbackOpera: RollbackOpera = {
            idopera: this.operaService.operaSession.idOpera,
            dataCompletamento: new Date()
      };
      this.operaService.updateRollbackOpera(rollbackOpera).subscribe({
            next: () => this.executeRipristinaInBozza(),
            error: () => {
              this.utilsService.showError('Errore salvataggio motivazione.');
            }
          });
      this.changedWithMotivation = false;
    }
  }

  public downloadPdf() {
    this.operaService
        .downloadOpera(this.operaService.operaSession.idOpera)
        .subscribe();
  }

  public initFormStato() {
    if (this.datalist.statoOpera) {
      this.statoOperaSelect = [...this.datalist.statoOpera];
      this.statoOperaSelect.splice(
          0,
          this.statoOperaSelect.findIndex(
              (f) => f.id === this.operaService.operaSession.idStato
          ) + 1
      );
      this.formStato = this.fb.group({
        stato: this.fb.control(this.statoOperaSelect[0]?.id),
      });
    }
  }

  onVisiblePage = () => {
    if (document.visibilityState === "visible") {
      this.checkChanges();
    } else if (this.windowClosed) {
      document.removeEventListener("visibilitychange", this.onVisiblePage);
      this.windowClosed = false;
    }
  };

  public isTrattiIdriciDifferent(opera1: Opera, opera2: Opera) {
    if (
        opera1.bacinoIdrografico !== opera2.bacinoIdrografico ||
        opera1.trattoIdrico !== opera2.trattoIdrico ||
        opera1.sottobacino !== opera2.sottobacino ||
        opera1.idSponda !== opera2.idSponda
    ) {
      return true;
    }
    return false;
  }

  public viewerOpened(win: Window) {
    document.addEventListener("visibilitychange", this.onVisiblePage);
    win?.addEventListener("beforeunload", (ev) => {
      this.windowClosed = true;
    });
  }
  // TODO: da completare
  // public export(typeExport: string) {
  //     this.operaService.export()
  // }

  public checkChanges() {
    this.operaService
        .read(this.operaService.operaSession.idOpera)
        .subscribe((opera: Opera) => {
          if (
              this.isTrattiIdriciDifferent(opera, this.criteriaForm.getRawValue())
          ) {
            this.criteriaForm.patchValue(opera);
            this.utilsService.showSuccess(
                "L'anagrafica dell'opera è stata aggiornata correttamente."
            );
          }
        });
  }

  public ripristinaInBozza(): void {
    const canEdit = !!this.permessiService?.opera?.['OPERA_EDIT'];
    if (!canEdit) {
      const modalRef = this.modalService.open(ModalMotivazioneComponent, { size: 'lg', centered: true });
      modalRef.componentInstance.title = 'Motivazione ripristino in bozza';
      modalRef.result.then((motivazione: string) => {
        if (!motivazione) { return; }
        const idOpera = this.operaService.operaSession?.idOpera;
        if (!idOpera) {
          this.utilsService.showWarning('Impossibile determinare l\'opera');
          return;
        }
        if (typeof this.operaService.saveRollbackOpera === 'function') {
          const rollbackOpera: RollbackOpera = {
            idopera: idOpera,
            notaMotivazione: motivazione,
            dataRollback: new Date(),
            idUtenteModifica: this.utenteService.utente.id
          };
          this.operaService.saveRollbackOpera(rollbackOpera).subscribe({
            next: () => this.executeRipristinaInBozza(),
            error: () => {
              this.utilsService.showError('Errore salvataggio motivazione.');
            }
          });
        } else {
          // salvataggio motivazione non implementato -> procedo comunque
          this.executeRipristinaInBozza();
        }
      }).catch(() => {
        // dismissed -> non procedere
      });
      return;
    }

    // utente ha permesso: procede normalmente
    this.executeRipristinaInBozza();
   }

  private executeRipristinaInBozza(): void {
    this.operaService
      .ripristinaInBozza(this.operaService.operaSession.idOpera)
      .subscribe({
        next: (success: boolean) => {
          this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
          if (success) {
            this.operaService.read(this.operaService.operaSession.idOpera)
              .subscribe((opera) => {
                this.operaService.operaSession = opera;
                this.criteriaForm.patchValue(opera);
                this.permessiService.initPermessiOpera();
                this.initFormStato();
                this.showActions = false;
                this.changedWithMotivation = true;
                Promise.resolve().then(() => this.showActions = true);
              });
          }
        },
        error: (err) => console.error("Errore durante il ripristino:", err),
      });
  }
}
